import { useEffect, useState } from "react";
import "./hero.css";
// import orchidStorageImg from "../../assets/orchid-storage-detail.jpeg";
import TurnkeyImg from "../../assets/whatwedo/turnkey.png";
import heroSection1 from "../../assets/shinde-house/shinde house c bed.png"; 
import heroSection2 from "../../assets/pranav-khot-house/kids-room.png"
// import bedroomStudyImg from "../../assets/bedroom-study.png";
// import TvRoomImg from "../../assets/warm-living-tv-unit.jpeg";
import diningRoomWideImg from "../../assets/renovation.png";
import orchidTvRoomImg from "../../assets/orchid-tv-room.png";


const SLIDES = [
  {
    src: heroSection1,
    alt: "Dining room with warm atmospheric lighting",
    featured: "Shinde House",
    location: "Nigadi Pradhikaran, Pune",
    area: "2200 SQ.FT.",
    description:
      "Architecture and interiors conceived as one continuous spatial experience.",
  },
  {
    src: heroSection2,
    alt: "Kids room with warm atmospheric lighting",
    featured: "Pranav Khot House",
    location: "Wakad, Pune",
    area: "750 SQ.FT.",
    description:
      "Full interior · kitchen, wardrobes, living, lighting",
  },
   {
    src: TurnkeyImg,
    alt: "TV Unit",
    featured: "Shinde House",
    location: "Nigadi Pradhikaran, Pune",
    area: "2200 SQ.FT.",
    description: " Complete renovation, including toilet, electrical work, flooring, and furniture.",
  },
  // {
  //   src: bedroomStudyImg,
  //   alt: "Bedroom study with soft natural light",
  //   featured: "Shinde House",
  //   location: "Nigadi Pradhikaran, Pune",
  //   area: "2200 SQ.FT.",
  //   description: " Complete renovation, including toilet, electrical work, flooring, and furniture.",
  // },
  {
    src: diningRoomWideImg,
    alt: "Wide dining room with expansive interior styling",
    featured: "Shinde House",
    location: "Nigadi Pradhikaran, Pune",
    area: "2200 SQ.FT.",
    description:
      " Complete renovation, including toilet, electrical work, flooring, and furniture.",
  },
  {
    src: orchidTvRoomImg,
    alt: "Orchid TV room showing warm modern interior finish",
    featured: "The Stellar Homes",
    location: "Wakad, Pune",
    area: "750 SQ.FT.",
    description:
      "Full interior · kitchen, wardrobes, living, lighting",
  },
  //  {
  //   src: TvRoomImg,
  //   alt: "Bedroom study with soft natural light",
  //   featured: "Courtyard House",
  //   location: "Nashik / India",
  //   area: "03,420 SQ.FT.",
  //   description: "Four white volumes turned inward around a single tree.",
  // },
];

export default function Hero() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % SLIDES.length);
    }, 3600);
    return () => clearInterval(id);
  }, []);

  const current = SLIDES[active];

  return (
    <section className="home-hero" aria-label="Introduction">
      <div className="home-hero-media">
        {SLIDES.map((slide, i) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className={i === active ? "home-hero-is-visible" : ""}
            loading={i === 0 ? "eager" : "lazy"}
          />
        ))}
      </div>

      <div className="home-hero-scrim" />

      <div className="home-hero-grid" aria-hidden="true">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <span key={i} style={{ animationDelay: `${0.3 + 0.09 * i}s` }} />
        ))}
      </div>

      <div className="home-hero-wrap home-hero-content">
        <h1
          className="home-hero-display home-hero-d-lg home-hero-title home-hero-title-multi"
          style={{ marginTop: "1.25rem" }}
        >
          <span>
            <i>Your Interior.</i>
          </span>
          <span>
            <i>Designed by Dwellora.</i>
          </span>
          <span className="home-hero-italic">
            <i>Crafted by Specialists.</i>
          </span>
        </h1>

        <div className="home-hero-foot">
          <div className="home-hero-meta home-hero-fade-seq home-hero-delay-2">
            <div>
              <p className="home-hero-label" style={{ color: "rgba(244,241,234,.6)" }}>
                Featured
              </p>
              <b>{current.featured}</b>
            </div>
            <div>
              <p className="home-hero-label" style={{ color: "rgba(244,241,234,.6)" }}>
                Location
              </p>
              <b>{current.location}</b>
            </div>
            <div>
              <p className="home-hero-label" style={{ color: "rgba(244,241,234,.6)" }}>
                Area
              </p>
              <b>{current.area}</b>
            </div>
          </div>

          <div className="home-hero-fade-seq home-hero-delay-3">
            {/* <p
              className="home-hero-lede"
              style={{ color: "rgba(244,241,234,.8)", marginBottom: "1.5rem" }}
            >
              {current.description}
            </p> */}
            <a href="#projects" data-cursor="cta" onClick={(event) => { event.preventDefault(); window.dispatchEvent(new CustomEvent("dwellora:open-contact")); }}>
              <span className="home-hero-btn">
                <span>Let's Consult</span>
                <svg
                   className="home-hero-arrow"
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 15L15 1M15 1H5M15 1V11"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />

                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* <span className="home-hero-scroll-cue" aria-hidden="true">
        Scroll
      </span> */}

    </section>
  );
}
